import {
  FETCH_MESSAGE
} from '@actions/types'

export const getMessages = (id) => ({
  type: FETCH_MESSAGE,
  payload: {
    request: {
      method: 'get',
      url: `/messages/v1/${id}`
    }
  }
})
